import { SiteSetting } from '@models/siteSetting';
import { httpGet, httpPost } from './apiService';
import { LanguageEntityAdminApiService } from './languageEntityAdminApiService';

export class SiteSettingAdminService extends LanguageEntityAdminApiService<SiteSetting> {
    constructor() {
        super('/api/admin/sitesetting');
    }

    async addOrUpdate(siteSetting: SiteSetting): Promise<Response> {
        return httpPost(`${this.baseUrl}/addupdate`, JSON.stringify(siteSetting));
    }

    async getByName(name?: string): Promise<SiteSetting> {
        const value = await httpGet(`${this.baseUrl}/name/${name}`);
        return value.json();
    }
}
